import $ from 'jquery';
import events from '../shared/events';
import {tesOrderControlInteraction} from './events';
import waitForElement from '../../../dom/waitforelement';
import wishList from '../wishlist';
import zipCode from '../../shared/zipcode';
import hideBVQAButton from '../shared/hidebvqabutton';
import spAddToWishList from '../../../vendor/googletagmanager/spevents/spaddtowishlist';
import {formatViewModelForEvent} from '../shared/formatviewmodelforevent';
import modal from '../../../smartpak/modal';

export default function belowTheFold(productClassViewModel, observe) {
    const $video = document.querySelector('.productClassVideo'),
        $bloomReach = document.getElementById('br-widgets'),
        $recentlyViewed = document.getElementById('recently-viewed-container'),
        $contentSections = document.querySelector('.content-sections');

    if ($video) {
        observe($video, () => {
            import('./videosection').then(({default: videoSection}) => videoSection.init());
        });
    }

    if ($bloomReach) {
        observe($bloomReach, () => {
            import('../../shared/bloomreach').then(({default: bloomReach}) =>
                bloomReach.init($bloomReach.querySelector('.BRRelatedProducts'), '.br-sf-widget')
            );
        });
    }

    if ($contentSections) {
        observe($contentSections, () => {
            import('./contentmanager').then(({default: contentManager}) => contentManager.init($contentSections));
        });
    }

    function calculateModalWidth() {
        const maxModalWidth = 1200;
        const windowWidth = window.innerWidth;
        const percentToSubtract = 0.1;
        const percentOfWidth = windowWidth * percentToSubtract;

        return windowWidth <= maxModalWidth ? windowWidth - percentOfWidth : maxModalWidth;
    }

    const buildCustomizationTable = (preferenceName, selectedCustomizationOptions) => {
        const tableBody = document.getElementById('customization-table-body');

        if (tableBody) {
            tableBody.innerHTML = `<tr>
            <td colspan="2" class="border-row-btm" id="prefRow">
                ${preferenceName}
            </td>
            </tr>
            ${selectedCustomizationOptions
                .map(
                    (item, index) => `<tr key="${index}">
                    <td class="opName">${item.optionName}</td>
                    <td class="opVal">${item.optionValue.join(', ')}</td>
                </tr>`
                )
                .join('')}`;
        }
    };

    const updateCustomizationTableLinks = () => {
        const tableContainer = document.getElementById('custAdded');
        const addCustomizationButton = document.getElementById('customization-modal');
        const deleteCustomization = document.querySelector('.deleteCustomization');

        if (tableContainer) {
            tableContainer.classList.add('show');
        }

        if (deleteCustomization && addCustomizationButton) {
            addCustomizationButton.innerHTML = 'Edit Customization';
            deleteCustomization.addEventListener('click', e => {
                e.preventDefault();
                productClassViewModel.customizationData(undefined);
                tableContainer.classList.remove('show');
                addCustomizationButton.innerHTML = `<span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"></path></svg></span> Customize Item</button>`;
            });
        }
    };

    const handleDOMSaveEvents = selectedCustomization => {
        buildCustomizationTable(selectedCustomization.PreferenceName, selectedCustomization.options);
        updateCustomizationTableLinks();
        productClassViewModel.customizationData(JSON.stringify(selectedCustomization));
    };

    const launchCustomizationModal = async () => {
        const $elementToRenderIn = document.createElement('div');
        const selectedCustomizationObj = productClassViewModel.customizationData();
        const priceOfProduct = parseFloat(productClassViewModel.price.current().replace('$', ''));
        const productClassId = productClassViewModel.id();

        const {default: customizationModal} = await import('./customizationmodal/Index');

        let handleClose;
        let modalInstance;

        handleClose = () => {
            modalInstance.close();
        };

        const {unmount} = customizationModal({
            $elementToRenderIn,
            productClassId,
            selectedCustomizationObj,
            priceOfProduct,
            handleDOMSaveEvents,
            handleClose
        });

        modalInstance = modal($elementToRenderIn, {
            title: 'Customization Options',
            width: calculateModalWidth(),
            close: unmount
        });
    };
    if (productClassViewModel.hasCustomization) {
        import('./customizer').then(({default: customizer}) => customizer.init(productClassViewModel));

        document.getElementById('customization-modal')?.addEventListener('click', async () => {
            launchCustomizationModal();
        });
    }

    waitForElement('.reviewStars .bv_numReviews_component_container', () => {
        import('../shared/reviews').then(({default: reviews}) => reviews.updateBVData());
    });

    waitForElement('[data-lazy-bv-show="questions"]', $element => hideBVQAButton($element));

    wishList.init(() => spAddToWishList(formatViewModelForEvent(ko.toJS(productClassViewModel))));

    if ($recentlyViewed) {
        observe($recentlyViewed, () => {
            import('../shared/recentlyviewed').then(({default: recentlyViewed}) =>
                recentlyViewed.init(document.getElementById('divRecentlyViewedProducts'))
            );
        });
    }

    $(document)
        .on('.asTip .tooltipTrigger', 'click', function () {
            tesOrderControlInteraction('AutoShip details click');
        })
        .on('click', '#productManufacturer a', function () {
            events._gaEvent('Product manufacturer click', window.location.href, 'Product Manufacturer');
        });

    waitForElement('#productClassCon [data-bv-show="rating_summary"] svg', function (elements) {
        if (elements) {
            [].slice.call(elements).forEach(function (element) {
                element.style.removeProperty('height');
                element.style.removeProperty('width');
            });
        }
    });

    $('#productClassCon').on('click', '.preferredZipCode', function (e) {
        e.preventDefault();
        zipCode._getPreferredZipCodeView();
    });
}
